import { useEffect } from "react";
import { useAuth } from "../../context/AuthContext";

declare global {
  interface Window {
    Tawk_API?: {
      setAttributes?: (
        attributes: Record<string, string>,
        callback?: (error: unknown) => void
      ) => void;
      onLoad?: () => void;
    };
    Tawk_LoadStart?: Date;
  }
}

export default function TawkChat() {
  const { user } = useAuth();

  useEffect(() => {
    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();

    const s1 = document.createElement("script");
    const s0 = document.getElementsByTagName("script")[0];

    s1.async = true;
    s1.src = "https://embed.tawk.to/6a3409214387da1d4a769e5a/1jrdk7bek";
    s1.setAttribute("crossorigin", "*");

    s0.parentNode?.insertBefore(s1, s0);

    return () => {
      s1.remove();
    };
  }, []);

  // Identify the user once Tawk is ready (or whenever user changes)
  useEffect(() => {
    if (!user) return;

    const identify = () => {
      window.Tawk_API?.setAttributes?.(
        {
          name: user.name,
          email: user.email,
        },
        (error) => {
          if (error) console.error("Tawk setAttributes error:", error);
        }
      );
    };

    if (window.Tawk_API?.setAttributes) {
      // Widget already loaded
      identify();
    } else {
      // Wait for widget to finish loading
      window.Tawk_API = window.Tawk_API || {};
      window.Tawk_API.onLoad = identify;
    }
  }, [user]);

  return null;
}
